import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import UploadField from '../formFields/UploadField';


/* ------ Validate / Warn  -------- */
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";
import CheckBoxField from "../formFields/CheckBoxField";

class Upload extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null,
            replacement:0,
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getCategoryList();
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }


    }
    __goBack(){
        this.props.history.goBack()
    }

    __getCategoryList() {
        let categoryList = this.props.categoryList;
        let dataSource = [];
        let categoryType;

        if (categoryList) {

            for (let i = 0; i < categoryList.length; i++) {
                if(categoryList[i].product_type === "PRODUCT_CATEGORY_CUSTOMER_TYPE")
                    categoryType = 'مشتری'
                else
                    categoryType = 'تکنسین'

                dataSource.push(
                    {label: categoryList[i].title+' ('+categoryType+')', value: categoryList[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    render() {

        return (
            <Field
                name="image"
                component={UploadField}
                token={this.props.userValue}
                type="file"
                label="تصویر محصول"
                placeholder="تصویر محصول"
                defaultValue={this.props.initialValues ? this.props.initialValues.image : null}
                help="سایز عکس میبایست حتما 150*150 پیکسل و با فرمت png باشد"
            />

        );
    }

}

export default Upload = reduxForm({
    form: 'Upload',
})(Upload)

//
// import React, {Component,PureComponent} from 'react';
// import {Field, reduxForm, FieldArray} from 'redux-form'
// import {Row, Form, Divider} from 'antd';
// import axios, { post } from 'axios';
// import {RTLCol,RTLButton} from '../RTLKit';
//
//
// class Upload extends Component {
//     constructor(props) {
//         super(props);
//         this.state ={
//             file: null
//         };
//         this.onFormSubmit = this.onFormSubmit.bind(this);
//         this.onChange = this.onChange.bind(this);
//     }
//     onFormSubmit(e){
//         e.preventDefault();
//         const formData = new FormData();
//         formData.append('image',this.state.file);
//         const config = {
//             'content-type': 'multipart/form-data',
//             'authorization': "Bearer "+this.props.userValue
//         };
//         axios.post("http://6a1e8c87.ngrok.io/upload",formData,config.headers)
//             .then((response) => {
//                 console.log(config)
//                 alert("The file is successfully uploaded");
//             }).catch((error) => {
//         });
//     }
//
//     onChange(e) {
//         this.setState({file:e.target.files[0]});
//     }
//
//     render() {
//         return (
//             <form onSubmit={this.onFormSubmit}>
//                 <h1>File Upload</h1>
//                 <input type="file" name="myImage" onChange= {this.onChange} />
//                 <button type="submit">Upload</button>
//             </form>
//         )
//     }
//
// }
//
// export default Upload = reduxForm({
//     form: 'Upload',
// })(Upload)
